import React, { SyntheticEvent } from 'react';

import { PrimaryButtonRouterLink } from './PrimaryButtonRouterLink';

export function CallToActionButton({
  loggedIn,
  loggedInText = 'Apply',
  loggedOutText = 'Sign Up',
  hasGradProgram,
  hasGradProgramText = 'Edit Grad Program',
  ...props
}: {
  'data-qa-id'?: string;
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  loggedIn: boolean;
  loggedInText?: string;
  loggedOutText?: string;
  hasGradProgram: boolean;
  hasGradProgramText?: string;
}) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  const ctaText = hasGradProgram
    ? hasGradProgramText
    : loggedIn
    ? loggedInText
    : loggedOutText;
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PrimaryButtonRouterLink to="/manage-grad-program" {...props}>
      {ctaText}
    </PrimaryButtonRouterLink>
  );
}
